import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostEdc_sharing_groupIdSimulate = z.any()
export type TagsPostEdc_sharing_groupIdSimulate = z.infer<typeof tagsPostEdc_sharing_groupIdSimulate>

export const paramsPostEdc_sharing_groupIdSimulate = z.object({ "groupId": z.string() })
export type ParamsPostEdc_sharing_groupIdSimulate = z.infer<typeof paramsPostEdc_sharing_groupIdSimulate>

export const bodyPostEdc_sharing_groupIdSimulate = z.object({ "from": z.string().date().optional(), "to": z.string().date().optional(), "keys": z.record(z.number().gte(0).lte(1)).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.number().gte(0).lte(1).safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
}) })
export type BodyPostEdc_sharing_groupIdSimulate = z.infer<typeof bodyPostEdc_sharing_groupIdSimulate>

export const responsePostEdc_sharing_groupIdSimulate = z.object({ "payload": z.object({ "totals": z.object({ "generation": z.number(), "consumption": z.number(), "shared": z.number(), "received": z.number(), "exported": z.number(), "purchased": z.number(), "missed": z.number() }), "points": z.array(z.object({ "key": z.string(), "shared": z.number() })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostEdc_sharing_groupIdSimulate = z.infer<typeof responsePostEdc_sharing_groupIdSimulate>

interface IPostEdc_sharing_groupIdSimulate extends BaseMethodType {
  tags: TagsPostEdc_sharing_groupIdSimulate,
  params: ParamsPostEdc_sharing_groupIdSimulate,
  body: BodyPostEdc_sharing_groupIdSimulate,
  response: ResponsePostEdc_sharing_groupIdSimulate
}
export const URL = '/edc-sharing/:groupId/simulate'
export const validation = {
  post: {
    tags: tagsPostEdc_sharing_groupIdSimulate,
    params: paramsPostEdc_sharing_groupIdSimulate,
    body: bodyPostEdc_sharing_groupIdSimulate,
    response: responsePostEdc_sharing_groupIdSimulate
  }
}
export interface Edc_sharing_groupIdSimulate extends BaseRouteType {
  post: IPostEdc_sharing_groupIdSimulate
}